import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { forumStats } from '@/mocks/rankings';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="container-custom py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-chat-3-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">海角论坛</span>
            </Link>
            <p className="text-sm leading-relaxed mb-4 text-background-50/60">
              海角论坛是深受用户喜爱的综合性交流社区平台，汇聚技术讨论、生活分享、数码评测、游戏娱乐等丰富内容，致力于为用户提供优质的互动交流体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="/" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="/" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="/" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">热门板块</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                  >
                    <i className={`${cat.icon} mr-1.5 text-xs`}></i>{cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快捷导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><Link to="/category/tech-discuss" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">技术交流</Link></li>
              <li><Link to="/category/game-entertainment" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">游戏娱乐</Link></li>
              <li><Link to="/category/digital-product" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">数码产品</Link></li>
              <li><Link to="/category/life-share" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">生活分享</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">社区数据</h4>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-background-50/5 rounded-lg p-3 text-center">
                <div className="text-lg font-bold text-primary-400 font-heading">{(forumStats.totalMembers / 10000).toFixed(0)}万</div>
                <div className="text-xs text-background-50/50 mt-0.5">注册会员</div>
              </div>
              <div className="bg-background-50/5 rounded-lg p-3 text-center">
                <div className="text-lg font-bold text-accent-400 font-heading">{(forumStats.totalPosts / 10000).toFixed(0)}万</div>
                <div className="text-xs text-background-50/50 mt-0.5">帖子总数</div>
              </div>
              <div className="bg-background-50/5 rounded-lg p-3 text-center">
                <div className="text-lg font-bold text-primary-400 font-heading">{forumStats.onlineUsers.toLocaleString()}</div>
                <div className="text-xs text-background-50/50 mt-0.5">当前在线</div>
              </div>
              <div className="bg-background-50/5 rounded-lg p-3 text-center">
                <div className="text-lg font-bold text-accent-400 font-heading">{forumStats.todayPosts.toLocaleString()}</div>
                <div className="text-xs text-background-50/50 mt-0.5">今日新帖</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="container-custom py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; 2026 海角论坛 Haijiao Forum. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <a href="/" className="hover:text-background-50/70 transition-colors">用户协议</a>
            <a href="/" className="hover:text-background-50/70 transition-colors">隐私政策</a>
            <a href="/" className="hover:text-background-50/70 transition-colors">社区规范</a>
            <a href="/about" className="hover:text-background-50/70 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}